// extracted by mini-css-extract-plugin
export default {"root":"ColorInput_root__TeO3w","inputContainer":"ColorInput_inputContainer__Ck6V0","colorPlaceholder":"ColorInput_colorPlaceholder__t+Ctk","button":"ColorInput_button__s8rIg"};